import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';
import { createRequestOption } from '../helpers/request-util';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {WebStorageCustomService} from '../commons/providers/web-custom-storage.service';

// Own
// Types
import { ColumnDefinitions } from '../commons/interfaces/types/column-definitions';

@Injectable({
  providedIn: 'root'
})
export class AgentesReportesService {

  public resourceUrl = environment.apiUrl + 'comparendo/' + 'comparendo';
  constructor(private http: HttpClient) { }

  // REPORTE TIPOS INFRACCION

  reporteTipoInfraccionData(req: { [key: string]: any }): Observable<{ [key: string]: any }[]> {
    const options = createRequestOption(req);
    return this.http.get<{ [key: string]: any }[]>(`${this.resourceUrl}/reporte_agente_tipo_infraccion`, { params: options });
  }

  getReporteTipoInfraccionColumnDefinitions(data: any[]): ColumnDefinitions[] {
    const columns: ColumnDefinitions[] = [];
    if (data.length > 0) {
      const reference = data[0];
      Object.keys(reference).forEach((key: string) => {
        // if (key !== 'camaraId' && key !== 'codigo' && key !== 'nombre') {
          columns.push({
            'columnName': key,
            'valueGetter': (item: any) => item[key] !== null ? item[key] : '',
            'columnType': 0
          });
        // }
      });
    }
    let newColumnDefinitions = [];
      newColumnDefinitions.push(columns.filter(e => e.columnName === 'Agente')[0]);
      columns.forEach((column) => {
        if (column.columnName !== 'Agente') {
          newColumnDefinitions.push(column);
        }
      });
    return newColumnDefinitions;
  }

  getReporteTipoInfraccionDataChart(content: any[], columns: ColumnDefinitions[], chartBaseObject: any, colors: string[]): any {
    const chart = JSON.parse(JSON.stringify(chartBaseObject));
    // chart.type = 'horizontalBar';
    chart.options.title.text = 'Tipos de infraccion';
    chart.options.legend.display = true;
    chart.data.datasets = [];
    content.forEach((element) => {
      chart.data.labels.push(element['Agente']);
    });

    console.log('COLUMNAS TIPO INFRACCION ', columns);

    columns.forEach((column: ColumnDefinitions, index: number) => {
      const data = [];
      content.forEach((content) => {
        data.push(content[column.columnName]);
      });
      if (column.columnName !== 'Agente') {
        chart.data.datasets.push({
          'data': data,
          'backgroundColor': colors[index],
          'label': column.columnName
        });
      }
    });

    console.log('GENERAR GRAFICO CON ', content, 'CHART ', chart);
    return chart;
  }

  // REPORTE MOTIVOS RECHAZO

  reporteMotivoRechazoData(req: { [key: string]: any }): Observable<{ [key: string]: any }[]> {
    const options = createRequestOption(req);
    return this.http.get<{ [key: string]: any }[]>(`${this.resourceUrl}/reporte_agente_motivo_rechazo`, { params: options });
  }

  getReporteMotivoRechazoColumnDefinitions(data: any[]): ColumnDefinitions[] {
    const columns: ColumnDefinitions[] = [];
    if (data.length > 0) {
      const reference = data[0];
      Object.keys(reference).forEach((key: string) => {
        // if (key !== 'camaraId' && key !== 'codigo' && key !== 'nombre') {
          columns.push({
            'columnName': key,
            'valueGetter': (item: any) => item[key] !== null ? item[key] : ''
          });
        // }
      });
    }
    let newColumnDefinitions = [];
      newColumnDefinitions.push(columns.filter(e => e.columnName === 'Agente')[0]);
      columns.forEach((column) => {
        if (column.columnName !== 'Agente') {
          newColumnDefinitions.push(column);
        }
      });
    return newColumnDefinitions;
  }

  getReporteMotivoRechazoDataChart(content: any[], columns: ColumnDefinitions[], chartBaseObject: any, colors: string[]): any {
    const chart = JSON.parse(JSON.stringify(chartBaseObject));
    // chart.type = 'horizontalBar';
    chart.options.title.text = 'Motivo de Rechazo';
    chart.options.legend.display = true;
    chart.data.datasets = [];
    content.forEach((element) => {
      chart.data.labels.push(element['Agente']);
    });

    console.log('COLUMNAS MOTIVO RECHAZO ', columns);

    columns.forEach((column: ColumnDefinitions, index: number) => {
      const data = [];
      content.forEach((content) => {
        data.push(content[column.columnName]);
      });
      if (column.columnName !== 'Agente') {
        chart.data.datasets.push({
          'data': data,
          'backgroundColor': colors[index],
          'label': column.columnName
        });
      }
    });

    console.log('GENERAR GRAFICO CON ', content, 'CHART ', chart);
    return chart;
  }

}
